import { createRouter, createWebHashHistory } from "vue-router";
import HomePresenter from "../presenters/HomePresenter.vue";
import ProfilePresenter from "../presenters/ProfilePresenter.vue";
import SettingsPresenter from "../presenters/SettingsPresenter.vue";
import SignUpPresenter from "../presenters/SignUpPresenter.vue";
import ConfirmationPresenter from "../presenters/ConfirmationPresenter.vue";
import CreationPresenter from "../presenters/CreationPresenter.vue";
import SteamGamePresenter from "../presenters/SteamGamePresenter.vue";
import AddSteamGamePresenter from "../presenters/AddSteamGamePresenter.vue";
import LanInfoPresenter from "../presenters/LanInfoPresenter.vue";

const routes = [
  { name: "Home", path: "/", component: HomePresenter },
  { name: "Profile", path: "/profile", component: ProfilePresenter },
  { name: "Settings", path: "/settings", component: SettingsPresenter },
  { name: "SignUp", path: "/signup/:id", component: SignUpPresenter },
  {
    name: "Confirmation",
    path: "/confirmation/:id",
    component: ConfirmationPresenter,
  },
  { name: "CreateEvent", path: "/create-event", component: CreationPresenter },
  { name: "SteamGame", path: "/steam-game/:id", component: SteamGamePresenter },
  {
    name: "AddSteamGame",
    path: "/steam-game/:id/add",
    component: AddSteamGamePresenter,
  },
  { name: "LanInfo", path: "/lan-info", component: LanInfoPresenter },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
